import SwiperPackage from "swiper";
import "swiper/css";
import swiperAccessibility from "../swiper-accessibility/swiperAccessibility.js";

window.CarouselAPI = window.CarouselAPI || {};
window.CarouselAPI.SwiperAPI = window.CarouselAPI.SwiperAPI || {};
window.CarouselAPI.Templates = window.CarouselAPI.Templates || {};
window.CarouselAPI.Utils = window.CarouselAPI.Utils || {};
window.localizedCarousel = window.carousel_data || {};

const CAROUSEL_CLASS = ".card-carousel-container";
const SWIPER_CLASS = ".swiper";
const SWIPER_WRAPPER_CLASSES = ".swiper .swiper-wrapper";
const SWIPER_SLIDE_CLASS = ".swiper-slide";
const PREV_BTN_CLASS = ".card-carousel-container .swiper-button-left";
const NEXT_BTN_CLASS = ".card-carousel-container .swiper-button-right";

Object.assign(window.CarouselAPI.SwiperAPI, {
  /**
   * Initialize ALL carousels on the page
   */
  initAll() {
    const blocks = document.querySelectorAll(CAROUSEL_CLASS);
    blocks.forEach((block) => window.CarouselAPI.SwiperAPI.init(block));
  },

  /**
   * Initialize current carousel instance
   */
  init(root) {
    if (!root) {
      return;
    }

    const swiperEl = root.querySelector(SWIPER_CLASS);
    if (!swiperEl) {
      return;
    }

    // Create Swiper INSTANCE (Swiper manages it internally)
    const instance = new SwiperPackage(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 32,
      loop: false,
      a11y: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    });

    if (!instance) {
      return;
    }

    const { setupAccessibility, listenButtons } = swiperAccessibility();

    setTimeout(() => {
      instance.update();
      const prevButton = root.querySelector(PREV_BTN_CLASS);
      const nextButton = root.querySelector(NEXT_BTN_CLASS);
      listenButtons(instance, prevButton, nextButton);
      setupAccessibility(instance);
    }, 50);
  },

  /**
   * Re-render all cards for given carousel root
   * Re-initialize Swiper instance for that carousel only
   * @param {*} root -- carousel root element
   * @param {*} cards -- array of card data
   */
  renderAllCards(root, cards) {
    const wrapper = root.querySelector(SWIPER_WRAPPER_CLASSES);
    if (!wrapper || !cards?.length) {
      return;
    }

    const cardTemplate = wrapper.querySelector(SWIPER_SLIDE_CLASS);
    const { renderCard } = window.CarouselAPI.Templates;
    if (!renderCard || !cardTemplate) {
      return;
    }

    // Destroy previous instance
    const swiperEl = root.querySelector(SWIPER_CLASS);

    const oldInstance = swiperEl?.swiper;
    if (oldInstance) {
      oldInstance.destroy(true, true);
    }

    // Re-render slides
    wrapper.innerHTML = cards
      .map((card) => renderCard(card, cardTemplate))
      .join("");

    // Remove animation classes
    const domCards = wrapper.querySelectorAll(SWIPER_SLIDE_CLASS);
    const { animationClass } = window.CarouselAPI.Utils;
    domCards.forEach((card) => card.classList.remove(animationClass));

    // Re-init THIS carousel only
    window.CarouselAPI.SwiperAPI.init(root);
  },
});
